import {flow, getEnv, types} from "mobx-state-tree";
import {GroupSelectState} from "../../elements/groups/GroupSelectState";
import {UtmSelectState} from "../../elements/utms/UtmSelectState";
import {Utm} from "../../../models/utms/UtmModel";
import {UtmParameterSelectState} from "../../elements/utms/UtmParameterSelectState";


export const UtmModalState = types.model("UtmModalState", {
  utm: types.maybe(Utm),
  isLoading: types.optional(types.boolean, false),
  isMadeDefault:types.optional(types.boolean, false),
  groupSelectStore: types.maybe(types.reference(GroupSelectState)),
  noUtmOpen:types.optional(types.boolean, false),
  customOpen:types.optional(types.boolean, true),
  utmSelectState:types.maybe(types.reference(UtmSelectState)),
  utmParameterSelectState: types.maybe(types.reference(UtmParameterSelectState)),
  isView: types.optional(types.boolean, false),
  selectVisibility: types.optional(types.frozen({}), {}),
  isRemovedUTM: types.optional(types.boolean, false),
  // campaignInputDisabled: types.optional(types.boolean, false),
  // sourceInputDisabled: types.optional(types.boolean, false),
  // mediumInputDisabled: types.optional(types.boolean, false),
  // termInputDisabled: types.optional(types.boolean, false),
  // contentInputDisabled: types.optional(types.boolean, false),
})
  .actions(self => {
    return ({
      initializeSelectVisibility() {
        const visibilityState = {};
        ["campaign", "source", "medium", "term", "content"].forEach(field => {
          visibilityState[field] = !!self.utm.utmParametersConfigs[`${field}SelectValue`];
        });
        self.selectVisibility = visibilityState;
      },
      toggleSelectVisibility(field) {
        const isCurrentlyVisible = self.selectVisibility[field];
        if (isCurrentlyVisible) {
          self.utm.updateSelectValue(field, null);
        } else {
          self.utm.updateInput(field, "");
        }
        self.selectVisibility = {
          ...self.selectVisibility,
          [field]: !isCurrentlyVisible
        };
      },
      removeSelectVisibility(field) {
        self.utm.updateSelectValue(field, null);
        self.selectVisibility = {
          ...self.selectVisibility,
          [field]: false
        };
      },
      handleIsDefault() {
        self.isMadeDefault = !self.isMadeDefault
        console.log(self)
      },
      setNoneOpen() {
        self.noUtmOpen = true
        self.presetsOpen = false
        self.customOpen = false
        self.utm.removeUTM = true;
      },
      setCustomOpen() {
        self.noUtmOpen = false
        self.presetsOpen = false
        self.customOpen = true
        self.utm.removeUTM = false;
      },
      consumeUtmSelect() {
        // self.utmSelectState.setConsumer(self.fetchUtmWithID)
        self.utmSelectState.setConsumer(flow(function* (uuid) {
          yield self.fetchUtmWithID(uuid); // Fetch and hydrate UTM
          self.initializeSelectVisibility();

        }));

      },
      fetchUtmWithID: flow(function* f(uuid) {
        const utmManager = getEnv(self).utmManager
        const res = yield utmManager.getUtm(uuid)
        self.utm.hydrateUtm(res)
      }),
      reset(customOpen = true) {
        self.noUtmOpen = !customOpen
        self.customOpen = customOpen
        self.utm.reset()
        self.isRemovedUTM = false
      },
      setOpenView() {
        if(self.utm.doesUtmHaveValue()) {
          self.setCustomOpen()
        }
      },
      setCampaignInputDisabled(bool) {
        self.utm.batchEditCampaignNochanges = !bool
        if (!bool) {
          self.removeSelectVisibility('campaign')
        }
      },
      setSourceInputDisabled(bool) {
        self.utm.batchEditSourceNochanges = !bool
        if (!bool) {
          self.removeSelectVisibility('source')
        }
      },
      setMediumInputDisabled(bool) {
        self.utm.batchEditMediumNochanges = !bool
        if (!bool) {
          self.removeSelectVisibility('medium')
        }
      },
      setTermInputDisabled(bool) {
        self.utm.batchEditTermNochanges = !bool
        if (!bool) {
          self.removeSelectVisibility('term')
        }
      },
      setContentInputDisabled(bool) {
        self.utm.batchEditContentNochanges = !bool
        if(!bool) {
          self.removeSelectVisibility('content')
        }
      },
    });
  }).views((self) => ({}))
// toastr.error(`Failure`, `${self.errorMessage}`)
